// hooks/useSocketEvents.js
import { useEffect } from 'react';
import { useSocket } from './contexts/SocketContext';

// Option 1: Your original pattern (recommended for your use case)
export const useSocketEvents = (events) => {
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;

    // Set up all event listeners
    events.forEach(({ event, handler }) => {
      socket.off(event, handler); // Remove old listener
      socket.on(event, handler);  // Attach new listener
    });

    // Cleanup function
    return () => {
      events.forEach(({ event, handler }) => {
        socket.off(event, handler);
      });
    };
  }, [socket, JSON.stringify(events)]); // Re-run when events array changes
};

// Option 2: Individual event hook
export const useSocketEvent = (event, handler, dependencies = []) => {
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;

    socket.on(event, handler);

    return () => {
      socket.off(event, handler);
    };
  }, [socket, event, handler, ...dependencies]);
};